module.exports = __webpack_public_path__ + "static/media/user_manual_banner.cbe719c3.svg";